import { ThemeUICSSObject, spacing } from '@apia/theme';

const documents: ThemeUICSSObject = {
  width: '100%',
  minWidth: '20vw',

  h4: {
    mb: spacing(0),
  },
};

export default documents;
